module.exports = __webpack_public_path__ + "media/videos/about-040cd9eace1770184151b64152ebfa05.mp4";